export default __webpack_public_path__ + "static/media/blank-shield.abcf09e5.svg";